  export const reportSubmenu = [
    {
      value: null,
      type: 'REPORT',
      name: 'Hành trình xe chạy',
      url: '/app/baocao-bgt/tt073/hanh-trinh-chay-xe'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Tốc độ vận hành của xe',
      url: '/app/baocao-bgt/tt073/toc-do-cua-xe'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Quá tốc độ cách nhau',
      url: '/app/baocao-bgt/tt073/qua-toc-do-gioi-han'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Thời gian lái xe liên tục',
      url: '/app/baocao-bgt/tt073/thoi-gian-lai-xe-lien-tuc'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo tổng hợp theo xe',
      url: '/app/baocao-bgt/tt073/bao-cao-tong-hop-theo-xe'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo tổng hợp theo lái xe',
      url: '/app/baocao-bgt/tt073/bao-cao-tong-hop-theo-lai-xe'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo dừng đỗ',
      url: '/app/baocao-bgt/tt073/thoi-gian-lai-xe-lien-tuc'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo hình ảnh',
      url: '/app/baocao-bgt/tt073/bao-cao-hinh-anh'
    },
  ]

  export const reportSubmenuTT09 = [
    // {
    //   value: null,
    //   type: 'REPORT',
    //   name: 'Tổng hợp vi phạm',
    //   url: '/app/baocao-bgt/tt09/tt09-phu-luc-5'
    // },
    // {
    //   value: null,
    //   type: 'REPORT',
    //   name: 'Thống kê vi phạm về tốc độ',
    //   url: '/app/baocao-bgt/tt09/tt09-phu-luc-8'
    // },
    // {
    //   value: null,
    //   type: 'REPORT',
    //   name: 'Chi tiết vi phạm tốc độ xe chạy',
    //   url: '/app/baocao-bgt/tt09/tt09-phu-luc-14'
    // },
    // {
    //   value: null,
    //   type: 'REPORT',
    //   name: 'Báo cáo lái xe quá 4h',
    //   url: '/app/baocao-bgt/tt09/tt09-phu-luc-16'
    // },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo chi tiết các cuốc lái xe trong ngày',
      url: '/app/baocao-bgt/tt09/tt09-phu-luc-17'
    },
    {
      value: null,
      type: 'REPORT',
      name: 'Báo cáo các cuốc lái xe trong tuần',
      url: '/app/baocao-bgt/tt09/tt09-phu-luc-9'
    },
    // {
    //   value: null,
    //   type: 'REPORT',
    //   name: 'Chi tiết vi phạm truyền dữ liệu',
    //   url: '/app/baocao-bgt/tt09/tt09-phu-luc-19'
    // }
  ]

  export const roadSubmenu = [
    // {
    //   value: 0.5,
    //   type:'ROAD',
    //   name: '30 phút gần đây',
    //   url: '/app/routing'
    // },
    {
      value: 1,
      type:'ROAD',
      name: '1 giờ gần đây',
      url: '/app/routing'
    },
    {
      value: 8,
      type:'ROAD',
      name: '8 giờ gần đây',
      url: '/app/routing'
    },
    {
      value: 'today',
      type:'ROAD',
      name: 'Ngày hôm nay',
      url: '/app/routing'
    },
    {
      value: 24,
      type:'ROAD',
      name: 'Ngày hôm qua',
      url: '/app/routing'
    },
    {
      value: 0,
      type:'ROAD',
      name: 'Tùy chọn',
      url: '/app/routing'
    },
  ]

  export const titleTableHeader = [
    {
      id: 1,
      name: 'Tên/Biển số',
      width: '50%',
    },
    {
      id: 2,
      name: 'Vận tốc\n(Km/h)',
      width: '15%',
    },
    {
      id: 3,
      name: 'Thời gian',
      width: '35%',
    },
  ]

  export const titleTableRoadMap = [
    {
      id:1,
      name:'Thời gian',
    },
    {
      id:2,
      name:'Vận tốc cơ',
    },
    {
      id:3,
      name:'Vận tốc GPS',
    },
    {
      id:4,
      name:'Động cơ',
    },
  ]
